import React from 'react';

import "./LoadingCircle.scss";

const LoadingCircle = ({show}: { show: boolean; }) => {

    return (<div className={`LoadingCircle Animated ${show?'Show':''}`} style={{width: '100%', height: '100%', position:'absolute', top: 0, left: 0}}>
        <div className='Holder Bottom'><div className={"Circle"}/></div>
        <div className='Holder Left'  ><div className={"Circle"}/></div>
        <div className='Holder Top'   ><div className={"Circle"}/></div>
        <div className='Holder Right' ><div className={"Circle"}/></div>
        <div className='Holder Center'><div className={"Circle"}/></div>
    </div>);
}

export default LoadingCircle;